import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { IntegrationProviderLiteFragmentDoc } from '../../../../../../../modules/corporate/modules/integrations/graphql/fragments/generated/IntegrationProviderLite';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type DateTagFilterTypeFragment = { id: string, name: string, type: Types.TagTypeEnum, category?: Types.TagCategoryEnum | null, includeEndDate: boolean, includeTime: boolean, integrationProvider?: { id: string, name: string, provider: Types.IntegrationProviderEnum } | null, settings: { iconSettings: { type: Types.IconTypeEnum, value: string } } };


export type DateTagFilterTypeFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export type TagFilterType_DateTagType_Fragment = { id: string, name: string, type: Types.TagTypeEnum, category?: Types.TagCategoryEnum | null, includeEndDate: boolean, includeTime: boolean, integrationProvider?: { id: string, name: string, provider: Types.IntegrationProviderEnum } | null, settings: { iconSettings: { type: Types.IconTypeEnum, value: string } } };

export type TagFilterType_MultiSelectTagType_Fragment = { id: string, name: string, type: Types.TagTypeEnum, category?: Types.TagCategoryEnum | null, integrationProvider?: { id: string, name: string, provider: Types.IntegrationProviderEnum } | null, settings: { iconSettings: { type: Types.IconTypeEnum, value: string } } };

export type TagFilterType_NumberTagType_Fragment = { id: string, name: string, type: Types.TagTypeEnum, category?: Types.TagCategoryEnum | null, integrationProvider?: { id: string, name: string, provider: Types.IntegrationProviderEnum } | null, settings: { iconSettings: { type: Types.IconTypeEnum, value: string } } };

export type TagFilterType_SingleSelectTagType_Fragment = { id: string, name: string, type: Types.TagTypeEnum, category?: Types.TagCategoryEnum | null, integrationProvider?: { id: string, name: string, provider: Types.IntegrationProviderEnum } | null, settings: { iconSettings: { type: Types.IconTypeEnum, value: string } } };

export type TagFilterType_TextTagType_Fragment = { id: string, name: string, type: Types.TagTypeEnum, category?: Types.TagCategoryEnum | null, integrationProvider?: { id: string, name: string, provider: Types.IntegrationProviderEnum } | null, settings: { iconSettings: { type: Types.IconTypeEnum, value: string } } };

export type TagFilterType_UserTagType_Fragment = { id: string, name: string, type: Types.TagTypeEnum, category?: Types.TagCategoryEnum | null, integrationProvider?: { id: string, name: string, provider: Types.IntegrationProviderEnum } | null, settings: { iconSettings: { type: Types.IconTypeEnum, value: string } } };

export type TagFilterTypeFragment = TagFilterType_DateTagType_Fragment | TagFilterType_MultiSelectTagType_Fragment | TagFilterType_NumberTagType_Fragment | TagFilterType_SingleSelectTagType_Fragment | TagFilterType_TextTagType_Fragment | TagFilterType_UserTagType_Fragment;


export type TagFilterTypeFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export type TagFilterQueryVariables = Types.Exact<{
  sort?: Types.InputMaybe<Array<Types.SortType> | Types.SortType>;
  filters?: Types.InputMaybe<Types.TagsFilters>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  first?: Types.InputMaybe<Types.Scalars['Float']['input']>;
  showProviders: Types.Scalars['Boolean']['input'];
}>;


export type TagFilterQuery = { tags?: { totalCount?: number | null, pageInfo?: { hasNextPage?: boolean | null, endCursor?: string | null } | null, edges?: Array<{ node: { id: string, name: string, type: Types.TagTypeEnum, category?: Types.TagCategoryEnum | null, includeEndDate: boolean, includeTime: boolean, integrationProvider?: { id: string, name: string, provider: Types.IntegrationProviderEnum } | null, settings: { iconSettings: { type: Types.IconTypeEnum, value: string } } } | { id: string, name: string, type: Types.TagTypeEnum, category?: Types.TagCategoryEnum | null, integrationProvider?: { id: string, name: string, provider: Types.IntegrationProviderEnum } | null, settings: { iconSettings: { type: Types.IconTypeEnum, value: string } } } | { id: string, name: string, type: Types.TagTypeEnum, category?: Types.TagCategoryEnum | null, integrationProvider?: { id: string, name: string, provider: Types.IntegrationProviderEnum } | null, settings: { iconSettings: { type: Types.IconTypeEnum, value: string } } } | { id: string, name: string, type: Types.TagTypeEnum, category?: Types.TagCategoryEnum | null, integrationProvider?: { id: string, name: string, provider: Types.IntegrationProviderEnum } | null, settings: { iconSettings: { type: Types.IconTypeEnum, value: string } } } | { id: string, name: string, type: Types.TagTypeEnum, category?: Types.TagCategoryEnum | null, integrationProvider?: { id: string, name: string, provider: Types.IntegrationProviderEnum } | null, settings: { iconSettings: { type: Types.IconTypeEnum, value: string } } } | { id: string, name: string, type: Types.TagTypeEnum, category?: Types.TagCategoryEnum | null, integrationProvider?: { id: string, name: string, provider: Types.IntegrationProviderEnum } | null, settings: { iconSettings: { type: Types.IconTypeEnum, value: string } } } }> | null } | null };

export const DateTagFilterTypeFragmentDoc = /*#__PURE__*/ gql`
    fragment DateTagFilterType on DateTagType {
  id
  name
  type
  category
  integrationProvider @include(if: $showProviders) {
    ...IntegrationProviderLite
  }
  settings {
    iconSettings {
      type
      value
    }
  }
  includeEndDate
  includeTime
}
    `;
export const TagFilterTypeFragmentDoc = /*#__PURE__*/ gql`
    fragment TagFilterType on TagUnion {
  ... on SingleSelectTagType {
    id
    name
    type
    category
    integrationProvider @include(if: $showProviders) {
      ...IntegrationProviderLite
    }
    settings {
      iconSettings {
        type
        value
      }
    }
  }
  ... on MultiSelectTagType {
    id
    name
    type
    category
    integrationProvider @include(if: $showProviders) {
      ...IntegrationProviderLite
    }
    settings {
      iconSettings {
        type
        value
      }
    }
  }
  ... on NumberTagType {
    id
    name
    type
    category
    integrationProvider @include(if: $showProviders) {
      ...IntegrationProviderLite
    }
    settings {
      iconSettings {
        type
        value
      }
    }
  }
  ... on UserTagType {
    id
    name
    type
    category
    integrationProvider @include(if: $showProviders) {
      ...IntegrationProviderLite
    }
    settings {
      iconSettings {
        type
        value
      }
    }
  }
  ... on DateTagType {
    ...DateTagFilterType
  }
  ... on TextTagType {
    id
    name
    type
    category
    integrationProvider @include(if: $showProviders) {
      ...IntegrationProviderLite
    }
    settings {
      iconSettings {
        type
        value
      }
    }
  }
}
    `;
export const TagFilterDocument = /*#__PURE__*/ gql`
    query tagFilter($sort: [SortType!], $filters: TagsFilters, $after: String, $first: Float, $showProviders: Boolean!) {
  tags(filters: $filters, sort: $sort, first: $first, after: $after) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        ...TagFilterType
      }
    }
  }
}
    ${TagFilterTypeFragmentDoc}
${IntegrationProviderLiteFragmentDoc}
${DateTagFilterTypeFragmentDoc}`;

export function useTagFilterQuery(options: Omit<Urql.UseQueryArgs<TagFilterQueryVariables>, 'query'>) {
  return Urql.useQuery<TagFilterQuery, TagFilterQueryVariables>({ query: TagFilterDocument, ...options });
};